import React, { memo } from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Cristal pedido mal y plata tirada a la basura', 'Mamparas que filtran agua y clientes que reclaman', 'Presupuestos a ojo, sin saber si ganás', 'Trabajás todo el día y al final no sabés cuánto ganaste'];
  return <section className="py-12 relative overflow-hidden" data-id="element-248">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-249">
        <FadeIn data-id="element-250">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 text-white" data-id="element-251">
            ¿Cuántos cristales más vas a perder{' '}
            <span className="text-red-400" data-id="element-252">trabajando de memoria?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-253">
          <p className="text-lg md:text-xl text-gray-300 text-center mb-8 leading-relaxed" data-id="element-254">
            Sabés lo que hacés. Pero calculás de cabeza, medís y rezás, instalás
            cruzando los dedos, y presupuestás por lo que el cliente acepta.
            <br data-id="element-255" />
            <br data-id="element-256" />
            <strong className="text-white" data-id="element-257">
              No es falta de habilidad. Es falta de un sistema.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-surface p-8 md:p-10 rounded-3xl border border-red-500/20 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-258">
          <ul className="space-y-6" data-id="element-259">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-260">
                <li className="flex items-start gap-4" data-id="element-261">
                  <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-262" />
                  <span className="text-lg text-gray-300" data-id="element-263">{point}</span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-264">
          <div className="mt-8 text-center" data-id="element-265">
            <p className="text-2xl md:text-3xl font-heading text-gold" data-id="element-266">
              ¿Y si este fuera el último trabajo que hacés sin sistema?
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}